import { createAsyncThunk } from '@reduxjs/toolkit'
import i18n from '../../lang/i18n'
import swaler from '../../utils/swaler'
import request from '../../utils/fetcher'

// Builds a thunk for a single parcel action; errors are shown via responseMessages when translated
const createParcelAction = (name, method, buildUrl, buildBody = () => ({})) =>
  createAsyncThunk(name, async (payload, thunkApi) => {
    try {
      const state = thunkApi.getState()
      return await request(method, buildUrl(payload), buildBody(payload), {
        headers: { 'x-iboxen-carrier': state.root.carrierHeader },
      })
    } catch (e) {
      let { message } = e
      const key = `responseMessages:${String(message).replaceAll(' ', '-')}`
      if (i18n.exists(key)) {
        message = i18n.t(key)
      }
      swaler.error(message)
      throw e
    }
  })

export const saveSupportNote = createParcelAction(
  'saveSupportNote',
  'PUT',
  ({ _id }) => `/carrier/parcels/${_id}/support-note`,
  ({ comment }) => ({ comment })
)

export const sendParcelEmail = createParcelAction(
  'sendParcelEmail',
  'POST',
  ({ _id }) => `/carrier/trigger/email/${_id}`,
  ({ template }) => ({ template })
)

export const sendResetPhoneEmail = createParcelAction(
  'sendResetPhoneEmail',
  'POST',
  ({ _id }) => `/carrier/trigger/reset-phone-email/${_id}`
)

export const resetConsumerAccess = createParcelAction(
  'resetConsumerAccess',
  'POST',
  ({ _id }) => `/carrier/parcels/${_id}/reset-consumer-access`
)

export const forceParcelStatus = createParcelAction(
  'forceParcelStatus',
  'PUT',
  ({ _id }) => `/carrier/parcels/${_id}/force-status`,
  ({ status }) => ({ status })
)

export const changePreviousBox = createParcelAction(
  'changePreviousBox',
  'PUT',
  ({ _id }) => `/carrier/parcels/${_id}/previous-box`,
  ({ boxId }) => ({ boxId })
)

export const setBankIdOverride = createParcelAction(
  'setBankIdOverride',
  'PUT',
  ({ _id }) => `/carrier/parcels/${_id}/bankid-override`,
  ({ enabled }) => ({ enabled })
)

export const clearBankIdSignatures = createParcelAction(
  'clearBankIdSignatures',
  'DELETE',
  ({ _id }) => `/carrier/parcels/${_id}/signatures`
)

export const changeParcelLocation = createParcelAction(
  'changeParcelLocation',
  'PUT',
  ({ _id }) => `/carrier/parcels/${_id}/location`,
  ({ locationNumber }) => ({ locationNumber })
)
